import React, { useState, useEffect } from 'react';
import axios from 'axios';
import configData from './Config.json';

import placeholderimage from './Assets/profile/default.jpg';

import './Profile.css';

//revision 20240418

function Profile({ state, setState, userid }) {

    const [profileuser, setProfileUser] = useState({ userid: '', username: '', userbiography: '', userprofilepicture: '' });

    const [loaded, setLoaded] = useState(false);

    const handleCloseModal = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    };

    useEffect(() => {
        setLoaded(false);

        const data = {
            userid: userid
        };

        axios.post(configData.SECUREURL + configData.GETPROFILE, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            },
        }).then(res => {
            if (res.data instanceof Object) {
                setProfileUser(res.data)
            }
        }).catch((err) => {
            console.log(err.response?.data?.message || err.message || 'Network error');
        }).finally(() => {
            setLoaded(true)
        })
    }, [])

    return (
        <div className='modal_body'>
            <div className='modal_printable'>
                <div className='profile_username'>{profileuser.username}</div>
                {
                    loaded ?
                        <img className='profile_userprofilepicture' src={profileuser.userprofilepicture} alt='Profile Picture' />
                        :
                        <img className='profile_userprofilepicture' src={placeholderimage} alt='Profile Picture' />
                }
                <div className='profile_userbiocontainer'>
                    <div className='profile_userbio'>
                        {profileuser.userbiography}
                    </div>
                </div>
            </div>
            <div className='modal_actions'>
                <div className='modal_buttons'>
                    <div className='modal_buttoncontainer'>
                        <button
                            className='modal_button'
                            onClick={() => handleCloseModal()} type='button'
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Profile;